import { Metamodel } from 'app/model/base/model';
import { BlobTypeStoreReadSettings } from './blob-type-store-read-settings';
import { AzureBlobFSLinkedService } from 'app/model/linkedservice/azure-blob-fs.linkedservice';
import { FilePathMode } from 'app/registries/consts/metadata-consts';

@Metamodel.model({
    name: 'AzureBlobFSReadSettings',
    display: [],
    tags: {
        linkedServiceModel: Metamodel.modelFor(AzureBlobFSLinkedService)
    }
})

export class AzureBlobFSStoreReadSettings extends BlobTypeStoreReadSettings {
    public supportedFilePathMode = [
        FilePathMode.DATASET,
        FilePathMode.WILDCARD,
        FilePathMode.LIST
    ];
}
